import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import { reactI18nextModule } from 'react-i18next'

const options = {
  loadPath: '/hello-react-i18next/locales/{{lng}}/{{ns}}.json',
  addPath: 'hello-react-i18next/locales/add/{{lng}}/{{ns}}'
}

i18n
  .use(XHR)
  .use(reactI18nextModule)
  .init({
  	fallbackLng: 'th',
  	ns: ['trans'],
  	defaultNS: 'trans',
  	debug: true,
  	interpolation: {
  		escapeValue: false
  	},
  	react: {
  		wait: true
  	},
    backend: options
  })

  export default i18n
  


// WEBPACK FOOTER //
// ./src/i18n.js